import { BasicComponent } from "haxt";

import "./Content.scss";
import { Router } from "../@noxtum/router/Router";

export class Content extends BasicComponent {

	protected override init(): void {
		this.ref(Router.onUpdate.addCallback(this.update, this));
	}

	public render() {
		let Page = Router.handler;
		return (
			<main class="Content">
				{Page}
			</main>
		);
	}
}
